export default "__VITE_ASSET__ChslNCHJ__"